function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M17.67 30.34a3.67 3.67 0 0 1-2.603-6.273A3.63 3.63 0 0 1 17.65 23a3.67 3.67 0 0 1 0 7.34h.02zm0-6.645a2.995 2.995 0 0 0-2.936 2.936 2.936 2.936 0 1 0 2.936-2.936z",
  fill: "#E4ECFF"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M17.67 28.07a1.41 1.41 0 1 1-.001-2.82 1.41 1.41 0 0 1 0 2.82z",
  stroke: "#E4ECFF",
  strokeWidth: 0.8
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M7.67 30.34a3.67 3.67 0 0 1-2.603-6.273A3.63 3.63 0 0 1 7.65 23a3.67 3.67 0 0 1 0 7.34h.02zm0-6.645a2.995 2.995 0 0 0-2.936 2.936 2.936 2.936 0 1 0 2.936-2.936z",
  fill: "#E4ECFF"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M7.67 28.07a1.41 1.41 0 1 1-.001-2.82 1.41 1.41 0 0 1 0 2.82z",
  stroke: "#E4ECFF",
  strokeWidth: 0.8
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M3 26.59H1V19h77.67l-.1 4h-3.66l-.26 1.53-1.52-.12-.83-1.33-6-.09-.16-.75h-6.9l-13.71 2.94H21.36l-.09-.24a3.81 3.81 0 0 0-3.68-2.45 4.09 4.09 0 0 0-3.53 2.54l-.09.23h-2.75l-.1-.22a4.13 4.13 0 0 0-3.48-2.53h-.07a3.82 3.82 0 0 0-3.42 2.28l-.09.22H3v1.58zm-1.26-.71h.54v-1.6h1.31a4.57 4.57 0 0 1 4-2.5h.09a4.72 4.72 0 0 1 4 2.75h1.81a4.72 4.72 0 0 1 4.08-2.77 4.65 4.65 0 0 1 4.28 2.69h23.6l13.72-2.94h7.5l.17.76 5.87.08.85 1.36h.5l.25-1.48h3.6v-2.49H1.72l.02 6.14z",
  fill: "#E4ECFF"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M77.49 19.52h-.72v3.11h.72v-3.11z",
  fill: "#E4ECFF"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M77.13 20.08H1.38v.72h75.75v-.72zM43.74 24.43h-1.28v-2.87h1.28v2.87zm-.92-.36h.56v-2.15h-.56v2.15zM37.17 24.43h-1.26v-2.87h1.29l-.03 2.87zm-.93-.36h.57v-2.15h-.57v2.15zM30.59 24.43h-1.28v-2.87h1.28v2.87zm-.92-.36h.56v-2.15h-.56v2.15zM24.02 24.43h-1.28v-2.87h1.28v2.87zm-.92-.36h.56v-2.15h-.56v2.15zM13.19 24.43h-1.28v-2.87h1.28v2.87zm-.92-.36h.56v-2.15h-.56v2.15zM59.59 23.85h-3v-1.7l3.07-.48-.07 2.18zm-2.33-.72h1.65v-.62l-1.62.25-.03.37z",
  fill: "#E4ECFF"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M58.91 25.54h-1.6v-2.37h1.56l.04 2.37zm-.88-.72h.15v-1h-.13l-.02 1zM58.91 29.11h-1.59v-3h1.59v3zm-.87-.72h.15v-1.65h-.15v1.65z",
  fill: "#E4ECFF"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M59.44 26.79h-2.75v-2h2.74l.01 2zm-2-.72h1.3v-.53h-1.3v.53zM59.42 29.64h-2.75v-1.27l2.75.02v1.25zM12.385 1.71C12.727.39 13.23 0 14.543 0h4.655c1.456 0 1.863.293 2.308 1.675H50.31C50.677.345 51.145 0 52.572 0h4.664c1.334 0 1.795.345 2.192 1.685.225.01.474.03.724.03 2.045 0 4.091.036 6.136-.018 1.429-.038 2.425.584 3.154 1.74.95 1.507 1.31 3.194 1.468 4.932.213 2.356.084 4.688-.77 6.925a8.625 8.625 0 0 1-1.032 1.897c-.604.848-1.445 1.25-2.537 1.25-20.691-.016-41.384-.016-62.078 0-1.179 0-2.032-.464-2.7-1.364-.886-1.199-1.31-2.584-1.533-4.03-.437-2.79-.383-5.557.622-8.242.238-.61.55-1.189.93-1.723.658-.944 1.579-1.395 2.77-1.386 2.583.034 5.168.014 7.803.014zM27.87 17.737h32.959V2.383h-2.067C58.536.707 58.45.635 56.742.633h-4.018c-1.383 0-1.555.165-1.667 1.542 0 .06-.06.119-.114.225H27.87v15.336zM20.815 2.393c-.12-1.349-.283-1.696-1.036-1.712a137.319 137.319 0 0 0-5.71 0c-.586.012-.93.396-.935 1.02 0 .204-.02.408-.034.693H8.806v15.334h15.17V2.393h-3.161zM61.579 17.78c1.65 0 3.224-.046 4.794.014 1.13.046 1.902-.424 2.45-1.33a8.195 8.195 0 0 0 .76-1.575c.866-2.517.907-5.1.494-7.697-.218-1.374-.578-2.726-1.513-3.797-.378-.433-.96-.923-1.477-.956-1.82-.116-3.648-.045-5.512-.045l.004 15.386zm-53.544-.036V2.38c-1.178 0-2.306.042-3.43-.011-1.059-.053-1.82.393-2.358 1.242a8.663 8.663 0 0 0-.817 1.625C.613 7.465.571 9.778.79 12.103c.141 1.453.476 2.866 1.234 4.138.414.694.91 1.414 1.774 1.477 1.397.09 2.805.026 4.237.026zm19.087-.157V2.42h-2.366v15.166h2.366z",
  fill: "#E4ECFF"
});

var SvgTankerTrailer = function SvgTankerTrailer(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 31,
    viewBox: "0 0 79 31",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTankerTrailer, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/tankerTrailer.3cb484c3.svg";
export { ForwardRef as ReactComponent };